import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (!socket) {
    const token = localStorage.getItem("flux_token");
    socket = io(process.env.REACT_APP_BACKEND_URL, {
      path: "/api/socket.io",
      auth: { token },
      transports: ["websocket", "polling"],
    });
  }
  return socket;
}

export function closeSocket() {
  if (socket) { socket.disconnect(); socket = null; }
}
